<template>
  <el-form ref="proform" label-width="135px" :inline="true" :model="form" :rules="formrule" class="demo-form-inline">
    <!-- 标题：文本类型，去空格校验 -->
    <el-form-item label="标题" prop="title">
      <el-input v-model="form.title" placeholder="标题" clearable />
    </el-form-item>

    <!-- 排序：非负整数 -->
    <el-form-item label="排序" prop="sort">
      <el-input v-model.number="form.sort" placeholder="排序" clearable />
    </el-form-item>

    <!-- 首页展示：下拉选择 -->
    <el-form-item label="首页展示" prop="home_display">
      <el-select v-model="form.home_display" placeholder="首页展示" clearable>
        <el-option v-for="item in booleanEnums" :label="item.label" :value="item.value" :key="item.value" />
      </el-select>
    </el-form-item>

    <!-- 是否邀请盈利：下拉选择 -->
    <el-form-item label="是否邀请盈利" prop="is_rebate">
      <el-select v-model="form.is_rebate" placeholder="是否邀请盈利" clearable>
        <el-option v-for="item in booleanEnums" :label="item.label" :value="item.value" :key="item.value" />
      </el-select>
    </el-form-item>

    <!-- 商品发布时间：日期字符串 -->
    <!-- <el-form-item label="商品发布时间" prop="product_release_time">
      <el-date-picker v-model="form.product_release_time" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="商品发布时间" />
    </el-form-item> -->

    <!-- 商品投保时间：日期字符串 -->
    <!-- <el-form-item label="商品投保时间" prop="product_insurance_time">
      <el-date-picker v-model="form.product_insurance_time" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="商品投保时间" />
    </el-form-item> -->

    <!-- 赠送实物产品：非必填（保持原有） -->
    <!-- <el-form-item label="赠送实物产品" prop="gift_goods">
      <el-select v-model="form.gift_goods" placeholder="赠送实物产品" clearable>
        <el-option v-for="item in goodsList" :label="item.title" :key="item.id" :value="item.id" />
      </el-select>
    </el-form-item> -->

    <!-- 等级收益：下拉选择 -->
    <el-form-item label="等级收益" prop="level_income">
      <el-select v-model="form.level_income" placeholder="首页展示等级收益" clearable>
        <el-option v-for="item in levelIncomeEnums" :label="item.label" :value="item.value" :key="item.value" />
      </el-select>
    </el-form-item>

    <!-- 到期赠送现金：非负金额 -->
    <el-form-item label="到期赠送现金" prop="gift_product_expires">
      <el-input v-model.number="form.gift_product_expires" type="number" placeholder="到期赠送现金" clearable />
    </el-form-item>

    <!-- 状态：下拉选择 -->
    <el-form-item label="状态" prop="status">
      <el-select v-model="form.status" placeholder="状态" clearable>
        <el-option v-for="item in saleStatusEnums" :label="item.label" :value="item.value" :key="item.value" />
      </el-select>
    </el-form-item>

    <!-- 项目分类：非必填（保持原有） -->
    <el-form-item label="项目分类" prop="class_id">
      <el-select v-model="form.class_id" placeholder="项目分类" clearable>
        <el-option v-for="item in typesEnum" :label="item.title" :key="item.id" :value="item.id" />
      </el-select>
    </el-form-item>

    <!-- 可购买的用户等级：非必填（保持原有） -->
    <el-form-item label="可购买的用户等级" prop="level">
      <el-select v-model="form.level" placeholder="可购买的用户等级" clearable>
        <el-option v-for="item in levelList" :label="item.title" :key="item.id" :value="item.id" />
      </el-select>
    </el-form-item>

    <!-- 投资金额：非负金额 -->
    <el-form-item label="投资金额" prop="invest">
      <el-input v-model.number="form.invest" type="number" placeholder="投资金额" clearable />
    </el-form-item>

    <!-- 项目总额(万)：非负数值 -->
    <el-form-item label="项目总额(万)" prop="invest_scale">
      <el-input v-model.number="form.invest_scale" type="number" placeholder="项目总额" clearable />
    </el-form-item>

    <!-- 发布份数：非负整数 -->
    <el-form-item label="发布份数" prop="publish_shares">
      <el-input v-model.number="form.publish_shares" type="number" placeholder="发布份数" clearable />
    </el-form-item>

    <!-- 限投次数：非负整数 -->
    <el-form-item label="限投次数" prop="invest_limit">
      <el-input v-model.number="form.invest_limit" type="number" placeholder="投资限投次数" clearable />
    </el-form-item>

    <!-- 收益类型：下拉选择 -->
    <el-form-item label="收益类型" prop="profit_type">
      <el-select v-model="form.profit_type" placeholder="收益类型" clearable>
        <el-option v-for="item in profitTypeEnums" :label="item.label" :key="item.value" :value="item.value" />
      </el-select>
    </el-form-item>

    <!-- 利率(%)：0-100之间的数值 -->
    <el-form-item label="利率(%)" prop="profit_rate">
      <el-input v-model.number="form.profit_rate" type="number" placeholder="每期收益率(%)" clearable />
    </el-form-item>

    <!-- 收益倍数：非负数值 -->
    <el-form-item label="收益倍数" prop="profit_more">
      <el-input v-model.number="form.profit_more" type="number" placeholder="收益倍数" clearable />
    </el-form-item>

    <!-- 项目周期(天)：至少1天的整数 -->
    <el-form-item label="项目周期(天)" prop="profit_cycle">
      <el-input v-model.number="form.profit_cycle" type="number" placeholder="项目周期" clearable />
    </el-form-item>

    <!-- 周期时间：下拉选择 -->
    <!-- <el-form-item label="周期时间" prop="profit_cycle_time">
      <el-select v-model="form.profit_cycle_time" placeholder="周期时间" clearable>
        <el-option v-for="item in cycleTimeEnums" :label="item.label" :value="item.value" :key="item.value" />
      </el-select>
    </el-form-item> -->

    <!-- 奖励积分：非负整数 -->
    <el-form-item label="奖励积分" prop="gift_points">
      <el-input v-model.number="form.gift_points" type="number" placeholder="兑换券" clearable />
    </el-form-item>

    <!-- 奖励抽奖：非负整数 -->
    <el-form-item label="奖励抽奖" prop="gift_raffle">
      <el-input v-model.number="form.gift_raffle" type="number" placeholder="奖励抽奖" clearable />
    </el-form-item>

    <!-- 现金奖励：非负金额 -->
    <el-form-item label="现金奖励" prop="gift_bonus">
      <el-input v-model.number="form.gift_bonus" type="number" placeholder="现金奖励" clearable />
    </el-form-item>

    <!-- 项目描述：文本类型，去空格 -->
    <el-form-item label="项目描述" prop="desc">
      <el-input v-model="form.desc" placeholder="项目描述" clearable />
    </el-form-item>

    <!-- 详情视频：URL格式校验（可选，根据需求调整） -->
    <el-form-item label="详情视频" prop="video_link">
      <el-input v-model="form.video_link" placeholder="详情视频" clearable />
    </el-form-item>

    <!-- 项目进度：0-100之间的数值 -->
    <el-form-item label="项目进度" prop="progress">
      <el-input v-model.number="form.progress" type="number" placeholder="项目进度" clearable />
    </el-form-item>

    <!-- 项目进度更新周期：下拉选择 -->
    <el-form-item label="项目进度更新周期" prop="progress_cycle">
      <el-select v-model="form.progress_cycle" placeholder="项目进度更新周期" clearable>
        <el-option v-for="item in cycleTimeEnums" :label="item.label" :value="item.value" :key="item.value" />
      </el-select>
    </el-form-item>

    <!-- 项目进度更新速率：非负数值 -->
    <el-form-item label="项目进度更新速率" prop="progress_rate">
      <el-input v-model.number="form.progress_rate" type="number" placeholder="项目进度更新速率" clearable />
    </el-form-item>
    <el-form-item label="项目图片" prop="img" :rules="[{ required: true, message: '请上传图片' }]">
      <el-upload class="upload-demo" style="width: 114px" :show-file-list="false" drag :headers="headers"
        :action="`${proxy.BASE_API_URL}index/upload`" :on-success="successUpload" :on-error="handleErr"
        :multiple="false">
        <img v-if="form.img" :src="proxy.IMG_BASE_URL + form.img" width="100%" height="114px" class="avatar" />
        <el-icon v-else class="avatar-uploader-icon">
          <Plus />
        </el-icon></el-upload>
    </el-form-item>

    <div style="border: 1px solid #ccc">
      <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
      <Editor style="height: 500px; overflow-y: hidden" v-model="form.content" :defaultConfig="editorConfig"
        :mode="mode" @onCreated="handleCreated" />
    </div>
  </el-form>
</template>

<script setup>
import { htmlDecodeByRegExp } from "@/utils/utils";
import {
  rolesEnums,
  profitTypeEnums,
  levelIncomeEnums,
  profitTypeBEnums,
  saleStatusEnums,
  cycleTimeEnums,
  booleanEnums,
} from "@/config/enums";
import {
  onBeforeUnmount,
  nextTick,
  ref,
  shallowRef,
  onMounted,
  getCurrentInstance,
} from "vue";
import { getTokenAUTH } from "@/utils/auth";
const form = ref({
  title: "",
  img: "",
  status: "",
  is_rebate: 1,
  sort: "",
  home_display: "",
  product_release_time: "",
  product_insurance_time: "",
  gift_goods: "",
  level_income: "",
  gift_product_expires: "",
  level: "",
  class_id: "",
  invest: "",
  invest_scale: "",
  publish_shares: "",
  invest_limit: "",
  profit_type: "",
  profit_rate: "",
  profit_more: "",
  profit_cycle: "",
  profit_cycle_time: "",
  gift_points: "",
  gift_raffle: "",
  gift_bonus: "",
  content: "",
  desc: "",
  video_link: "",
  progress: "",
  progress_cycle: "",
  progress_rate: "",
  // sales_time: "",
  // sales_limit: "",
  // gift_coupon: "",
  // coupon_limit: "",
});
// 给form加必填规则
const formrule = ref({
  title: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
  img: [{ required: true, message: "请上传图片", trigger: "blur" }],
  status: [{ required: true, message: "请选择状态", trigger: "blur" }],
  is_rebate: [{ required: true, message: "请选择是否返利", trigger: "blur" }],
  sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
  home_display: [{ required: true, message: "请选择是否首页展示", trigger: "blur" }],
  // product_release_time: [{ required: true, message: "请选择发布时间", trigger: "blur" }],
  // product_insurance_time: [{ required: true, message: "请选择保险时间", trigger: "blur" }],
  // gift_goods: [{ required: true, message: "请选择赠送商品", trigger: "blur" }],
  level_income: [{ required: true, message: "请选择等级收益", trigger: "blur" }],
  // gift_product_expires: [{ required: true, message: "请选择赠送商品有效期", trigger: "blur" }],
  level: [{ required: true, message: "请选择等级", trigger: "blur" }],
  class_id: [{ required: true, message: "请选择分类", trigger: "blur" }],
  invest: [{ required: true, message: "请输入投资金额", trigger: "blur" }],
  invest_scale: [{ required: true, message: "请输入投资比例", trigger: "blur" }],
  invest_limit: [{ required: true, message: "请输入投资限制", trigger: "blur" }],
  profit_type: [{ required: true, message: "请选择收益类型", trigger: "blur" }],
  profit_rate: [{ required: true, message: "请输入收益率", trigger: "blur" }],
  profit_more: [{ required: true, message: "请输入额外收益", trigger: "blur" }],
  profit_cycle: [{ required: true, message: "请输入项目周期", trigger: "blur" }],
  // profit_cycle_time: [{ required: true, message: "请输入项目周期时间", trigger: "blur" }],
  gift_points: [{ required: true, message: "请输入赠送积分", trigger: "blur" }],
  gift_raffle: [{ required: true, message: "请输入赠送抽奖", trigger: "blur" }],
  gift_bonus: [{ required: true, message: "请输入赠送分红", trigger: "blur" }],
  content: [{ required: true, message: "请输入内容", trigger: "blur" }],
  desc: [{ required: true, message: "请输入描述", trigger: "blur" }],
  // video_link: [{ required: true, message: "请输入视频链接", trigger: "blur" }],
  // progress: [{ required: true, message: "请输入项目进度", trigger: "blur" }],
  // progress_cycle: [{ required: true, message: "请输入项目进度周期", trigger: "blur" }],
  // progress_rate: [{ required: true, message: "请输入项目进度比例", trigger: "blur" }],
}
)
const props = defineProps(["item"]);

const headers = ref({});
const proform = ref(null)
onMounted(() => {
  headers.value["Accept-Token"] = getTokenAUTH();
  nextTick(() => {
    if (props.item.content) {
      props.item.content = htmlDecodeByRegExp(props.item.content);
    }
    form.value = Object.assign(form.value, props.item);
    setTimeout(() => {

      proform.value?.clearValidate();
    }, 0);
  });
  getTYpesEnum();
  getLevelList();
  getGoodsList();
});

const { proxy } = getCurrentInstance();
const levelList = ref([]);
const getLevelList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Level/getLevelLists",
  });
  if (res.code == 0) {
    levelList.value = [{ title: "普通会员", id: 0 }, ...res.data.data];
  }
};

const goodsList = ref([]);

const getGoodsList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Goods/getGoodsLists",
    params: {
      page: 1,
      limit: 999,
    },
  });

  if (res.code == 0) {
    goodsList.value = res.data.data;
  }
};

const typesEnum = ref([]);

const getTYpesEnum = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Item/getItemClassLists",
  });
  if (res.code == 0) {
    typesEnum.value = res.data.data;
  }
};

const successUpload = (res) => {
  form.value.img = res.data.url;
};

const handleErr = (err) => {
  if (err.status == 320) {
    form.value.img = JSON.parse(err.message).data.url;
  }
};

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();

// 内容 HTML
const valueHtml = ref("<p>hello</p>");
const mode = ref("default");

const toolbarConfig = {};
const editorConfig = {
  placeholder: "请输入内容...",
  MENU_CONF: {
    uploadImage: {
      fieldName: "file",
      maxFileSize: 10 * 1024 * 1024, // 10M
      server: proxy.BASE_API_URL + "index/uploadX",
      headers: {
        "Accept-Token": getTokenAUTH(),
      },
      customInsert(res, insertFn) {
        const url = proxy.IMG_BASE_URL + res.data.url;
        const alt = res.data.alt;
        const href = res.data.href;
        insertFn(url, alt, href);
      },
    },
  },
};

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});

const handleCreated = (editor) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
};

defineExpose({ form, proform });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}

/deep/ .el-radio-group {
  width: 220px;
}

.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
